
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto py-16 px-4 text-center">
      <h1 className="text-3xl font-bold mb-6">Access Denied</h1>
      <p className="mb-6">You do not have permission to access the sales dashboard.</p>
      <button
        onClick={() => navigate('/')}
        className="bg-primary text-white px-4 py-2 rounded"
      >
        Return to Home
      </button>
    </div>
  );
};
